
import Checkbox from '@/components/Folders/Checkbox'
import FilesystemDragNode from '@/components/Folders/Nodes/FilesystemDragNode'
import FilesystemNodeIcon from '@/components/Folders/FilesystemNodeIcon'
import { copyComponent } from '@/Utils/copyComponent'
import Badge from '@/components/UntitledUI/Badge.vue'
export default {
    name: 'FilesystemNode',
    components: { FilesystemNodeIcon, Checkbox, FilesystemDragNode, Badge },
    props: {
        node: {
            type: Object,
            required: true
        },
        showOwner: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            dragged: false,
            dragOver: false,
            selected: false
        }
    },
    computed: {
        owner () {
            if (this.node?.owner?.id === this.$auth.user.id) {
                return this.$t('my folders me')
            }

            return this.node?.owner?.name?.split(' ')[0]
        },
        lastModified () {
            const date = new Date(this.node.updated_at)
            return `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`
        },
        canDragOver () {
            return this.node.node_type === 'd' && !this.dragged && !this.$store.getters['folders/selectedNodes'].includes(this.node.id)
        },
        isSelected () {
            return this.$store.getters['folders/selectedNodes'].includes(this.node.id)
        }
    },
    watch: {
        selected (value) {
            this.$emit('select', value)
        },
        isSelected: {
            handler (value) {
                this.selected = value
            },
            immediate: true
        }
    },
    methods: {
        show () {
            if (this.node.is_trashed) {
                this.selected = !this.selected
                return
            }
            this.$emit('show', this.node)
        },
        startDrag (e) {
            const dragEl = copyComponent(FilesystemDragNode, {
                propsData: {
                    node: this.node,
                    selectedNodesCount: this.$store.getters['folders/selectedNodes'].length
                }
            })

            document.body.appendChild(dragEl.$el)
            e.dataTransfer.setDragImage(dragEl.$el, 250, 0)

            setTimeout(() => document.body.removeChild(dragEl.$el), 150)

            this.dragged = true
            this.$emit('drag-start', this.node)
        },
        overDrag (e) {
            this.dragOver = true
            e.dataTransfer.dropEffect = this.canDragOver ? 'move' : 'none'
        },
        endDrag (e) {
            this.dragged = false
            this.$store.commit('folders/endDrag')
        },
        drop (e) {
            this.dragOver = false
            if (!this.canDragOver) {
                return
            }
            this.$emit('drag-end', this.node)
        }
    }
}
